import services from '@/services/ascentiaServiceIndex'
import { FEATURE_CONSTS as FEA } from '../consts'

const state = {
  allFeaturesByModule: [],
}

const getters = {}

const mutations = {
  [FEA.UPDATE_ALL_FEATURES_BY_MODULE]: (state, data) =>
    (state.allFeaturesByModule = data),
}

const actions = {
  async [FEA.GET_ALL_FEATURES_BY_MODULE]({ commit }, { id, isAdmin = false }) {
    try {
      const response = await services.feature.getData(
        'allFeaturesByModule',
        { analyticModuleId: id, admin: isAdmin },
        true,
      )
      const data = response.data
      commit(FEA.UPDATE_ALL_FEATURES_BY_MODULE, data)
    } catch (error) {
      console.log(`${[FEA.GET_ALL_FEATURES_BY_MODULE]}: error ${error}`)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async [FEA.SAVE_FEATURE]({ commit }, feature) {
    try {
      await services.feature.saveData('saveFeature', feature)
    } catch (error) {
      console.log(`${[FEA.SAVE_FEATURE]}: error ${error}`)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
